import { render, staticRenderFns } from "./UpdateChildrenStatusForm.vue?vue&type=template&id=64628dd2&scoped=true&"
import script from "./UpdateChildrenStatusForm.vue?vue&type=script&lang=js&"
export * from "./UpdateChildrenStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateChildrenStatusForm.vue?vue&type=style&index=0&id=64628dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64628dd2",
  null
  
)

export default component.exports